<template>
  <div class="content">
    <ArtistSelect
      @memberChangeEvent="getArtistInfo"
      :is-filter="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
      :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
    />
    <SimpleSearch @simpleSearchEvent="setKeyword" />
    <div class="row">
      <div class="col-md-10">
        <el-date-picker v-model="currentMonth" type="month" placeholder="Pick a month"> </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-radio name="calendar" inline v-model="viewType">캘린더</base-radio>
        <base-radio name="list" inline v-model="viewType">리스트</base-radio>
      </div>
    </div>
    <div v-show="viewType === 'calendar'" class="row">
      <div class="col-12">
        <full-calendar
          id="fullCalendar"
          v-bind="calendarOptions"
          :events="events"
          contentHeight="auto"
          ref="fullCalendar"
          @eventClick="onEventClick"
          @datesRender="datesRender"
        />
      </div>
    </div>
    <div v-show="viewType === 'list'" class="row">
      <div class="col-md-12">
        <FullCalendarHeader :year="year" :month="month" @change="onChangeMonth" @goFormPage="goFormPage" />
      </div>
      <div class="col-md-12">
        <el-table :data="events" :row-class-name="tableRowClassName">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          <el-table-column :min-width="135" align="right" label="Actions">
            <div slot-scope="props">
              <base-button v-if="props.row.id" @click.native="handleEdit(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import { Table, TableColumn } from "element-ui";

import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import SimpleSearch from "@/pages/Components/SimpleSearch.vue";
import FullCalendarHeader from "@/pages/Components/FullCalendarHeader.vue";
import * as moment from "moment";
import { URLUtils } from "@/util/URLUtils";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
  components: {
    FullCalendar,
    ArtistSelect,
    SimpleSearch,
    FullCalendarHeader,
    moment,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getScheduleTypes();
  },
  watch: {
    currentMonth() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(this.currentMonth);
      this.year = this.currentMonth.getFullYear();
      this.month = this.currentMonth.getMonth() + 1;
    },
  },
  data() {
    return {
      unitId: "",
      memberId: "",
      keyword: null,
      year: y,
      month: m + 1,
      currentMonth: null,
      viewType: "calendar",
      scheduleTypes: [],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "scheduleId",
          label: "스케줄ID",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작일",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료일",
          minWidth: 150,
        },
        {
          prop: "title",
          label: "제목",
          minWidth: 120,
        },
        {
          prop: "memberName",
          label: "관련멤버",
          minWidth: 120,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 120,
        },
        {
          prop: "userId",
          label: "유저아이디",
          minWidth: 120,
        },
      ],
      events: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        theme: true,
        defaultView: "dayGridMonth",
        header: {
          left: "title",
          // center: "dayGridMonth,timeGridWeek,timeGridDay",
          right: "prev,next,today",
        },
        defaultDate: today,
        selectable: true,
        selectHelper: true,
        views: {
          month: {
            // name of view
            titleFormat: {
              month: "long",
              year: "numeric",
            },
            // other view-specific options here
          },
          week: {
            titleFormat: {
              month: "long",
              day: "2-digit",
              year: "numeric",
            },
          },
          day: {
            titleFormat: {
              day: "2-digit",
              month: "long",
              year: "numeric",
            },
          },
        },
        // editable: true,
        eventLimit: true, // allow "more" link when too many events

        // color classes: [ event-blue | event-azure | event-green | event-orange | event-red ]
        events: self.events,
      },
    };
  },
  methods: {
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
      });
    },
    async onSelect({ start, end }) {},
    onChangeMonth(date) {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date.toDate());
    },
    onEventClick(event) {
      const suggestionId = event.event.id;
      if (suggestionId == "") {
        return;
      }
      this.$router.push(`/schedules/scheduleSuggestionForm?suggestionId=${suggestionId}&unitId=${this.unitId}`);
    },

    handleEdit(suggestionId) {
      this.$router.push(`/schedules/scheduleSuggestionForm?suggestionId=${suggestionId}&unitId=${this.unitId}`);
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.state == 1) {
        if (row.scheduleId) {
          return "modify-row";
        } else {
          return "add-row";
        }
      } else {
        return "";
      }
    },

    goFormPage() {
      this.$router.push(`/schedules/scheduleSuggestionForm?unitId=${this.unitId}`);
    },
    async datesRender(view, element) {
      const calendarApi = this.$refs.fullCalendar.getApi();
      this.year = calendarApi.getDate().getFullYear();
      this.month = calendarApi.getDate().getMonth() + 1;
      await this.getList();
    },

    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getList();
    },

    async setKeyword(param) {
      if (param.keyword != "") {
        this.keyword = param.keyword;
      } else {
        this.keyword = null;
      }
      await this.getList();
    },
    async getList() {
      if (!this.unitId) {
        return;
      }

      const startTime = moment(`${this.year}-${this.month}-1`, "YYYY-M-D").toISOString();
      const endTime = moment(`${this.year}-${this.month}-1`, "YYYY-M-D").endOf("month").toISOString();

      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };
      const path = `/schedules/scheduleSuggestion?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get("/schedule/suggestions", {
          params: { unitId: this.unitId, memberId: this.memberId, keyword: this.keyword, year: this.year, month: this.month, startTime, endTime },
        })
        .then((res) => {
          this.events = [];
          const data = res.data.data;
          data.forEach((d) => {
            const obj = {};
            obj.id = d.suggestionId;
            obj.scheduleId = d.scheduleId;
            for (let i = 0; i < this.scheduleTypes.length; i++) {
              const type = this.scheduleTypes[i];
              if (d.typeId === type.id) {
                obj.type = type.name;
                break;
              }
            }
            obj.userId = d.userId;
            obj.title = d.title;
            obj.start = d.startTime;
            obj.end = d.endTime;
            obj.allDay = d.isAllDay === 1;
            obj.members = d.members;
            obj.state = d.state;
            obj.startTime = moment(d.startTime).format("Y-MM-DD HH:mm:ss");
            obj.endTime = moment(d.endTime).format("Y-MM-DD HH:mm:ss");
            if (obj.state === 1) {
              if (obj.scheduleId) {
                obj.color = "blue";
              } else {
                obj.color = "red";
              }
            } else {
              obj.color = "black";
            }
            if (obj.members.length > 0) {
              obj.memberName = "";

              obj.members.forEach((item) => {
                obj.memberName += item.name;
              });
            } else {
              obj.memberName = "전체";
            }
            this.events.push(obj);
          });
        });
    },
  },
};
</script>
<style>
#fullCalendar {
  min-height: 400px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}
.el-table .modify-row td div {
  color: #2600ff !important;
}

.el-table .add-row td div {
  color: red !important;
}
</style>
